import { render, staticRenderFns } from "./BuildInfo.vue?vue&type=template&id=987bdeec&"
import script from "./BuildInfo.vue?vue&type=script&lang=js&"
export * from "./BuildInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports